import { EventBus } from '@baishuyun/types';

export { type EventBus };

export function createEventBus<Events extends Record<string, unknown>>(): EventBus<Events> {
  const listeners = new Map<keyof Events, Set<(data: Events[keyof Events]) => void>>();

  return {
    on<K extends keyof Events>(event: K, callback: (data: Events[K]) => void): () => void {
      if (!listeners.has(event)) {
        listeners.set(event, new Set());
      }
      const set = listeners.get(event)!;
      const cb = callback as (data: Events[keyof Events]) => void;
      set.add(cb);
      return () => {
        set.delete(cb);
      };
    },

    emit<K extends keyof Events>(event: K, data: Events[K]): void {
      const set = listeners.get(event);
      if (!set) return;
      set.forEach((callback) => callback(data as Events[keyof Events]));
    },
  };
}
